import { fetchQuery, graphql, type Environment } from 'react-relay';
import {
    type zipCodeLookupQuery,
    type zipCodeLookupQuery$data,
} from './__generated__/zipCodeLookupQuery.graphql.ts';

export async function zipCodeLookup(
    environment: Environment,
    args: {
        zipCode: string;
        country: string;
    }
): Promise<zipCodeLookupQuery$data | null> {
    const response = await fetchQuery<zipCodeLookupQuery>(
        environment,
        graphql`
            query zipCodeLookupQuery($zipCode: String!, $country: String!) {
                viewer {
                    zipCode(zipCode: $zipCode, country: $country) {
                        city
                        state
                        country
                    }
                }
            }
        `,
        args
    ).toPromise();

    return response || null;
}
